const Messages = () => import('vue-chat/components/Messages');

function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  Vue.component('messages', Messages);
}

export default {
  install
};
